import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { BookingDialogProvider } from "@/context/BookingDialogContext";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Facilities from "@/pages/Facilities";
import FacilityDetail from "@/pages/FacilityDetail";
import CalendarPage from "@/pages/CalendarPage";
import Bookings from "@/pages/Bookings";
import Staff from "@/pages/Staff";

const AdminOnly = ({ children }) => {
  const { user } = useAuth();
  return user?.role === "admin" ? children : <Navigate to="/" replace />;
};

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <BookingDialogProvider>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route element={<Layout />}>
              <Route index element={<Dashboard />} />
              <Route path="strutture" element={<Facilities />} />
              <Route path="strutture/:slug" element={<FacilityDetail />} />
              <Route path="calendario" element={<CalendarPage />} />
              <Route path="prenotazioni" element={<Bookings />} />
              <Route path="personale" element={<AdminOnly><Staff /></AdminOnly>} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <Toaster position="top-right" richColors />
        </BookingDialogProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
